const testIds = {
  hotel_name: 'hotel_general_info_hotel_name',
  hotel_address: 'hotel_general_info_hotel_address',
  hotel_access: 'hotel_general_info_hotel_access',
  hotel_map: 'hotel_general_info_hotel_map',
  hotel_average_rating: 'hotel_average_rating',
  number_of_reviews: 'number_of_reviews',
  positive_summary: 'positive_summary',
  review_sub_category: 'review_sub_category',
};

export default testIds;
